var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlarm = function SvgAlarm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.667 15.417c.69 0 1.25.56 1.25 1.25v.016a1.25 1.25 0 0 1-2.5 0v-.017c0-.69.56-1.25 1.25-1.25"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.712 8.712a11.25 11.25 0 0 1 16.393 15.394 4.58 4.58 0 0 1 2.565 2.745 8.245 8.245 0 0 0 5.543-10.604 2.916 2.916 0 1 1 2.305-.981 10.747 10.747 0 0 1-7.601 14.105V30a4.583 4.583 0 0 1-4.584 4.583H10A4.583 4.583 0 0 1 5.417 30v-1.667a4.58 4.58 0 0 1 2.811-4.227 11.25 11.25 0 0 1 .484-15.394m16.705 19.603V30a2.083 2.083 0 0 1-2.084 2.083H10A2.083 2.083 0 0 1 7.917 30v-1.667A2.083 2.083 0 0 1 10 26.25h.774a11.25 11.25 0 0 0 11.785 0h.774a2.083 2.083 0 0 1 2.084 2.066m-8.75-20.399a8.75 8.75 0 1 0 0 17.5 8.75 8.75 0 0 0 0-17.5",
    clipRule: "evenodd"
  })));
};
export default SvgAlarm;